<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row no-gutters>
        <v-col
          cols="12"
          md="6"
          class="py-6 px-md-6"
          v-for="(item, i) in categories"
          :key="i"
        >
          <!-- <div class="rowinfo"> -->
          <cat-card :item="item">
            <template>
              <help-info
                :element-name="`${serviceName}-${componentName}-catBusinessShop-${item.route}`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="`${item.name}`"
                :style="{
                  opacity: item.comingSoon ? 0.2 : 1,
                  'pointer-events': item.comingSoon ? 'none' : 'auto',
                  top: '46%',
                  boxShadow: 'none',
                  left: '4%',
                  position: 'relative',
                }"
              />
            </template>
          </cat-card>
          <!-- </div> -->
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import CatCard from "./catCard";

export default {
  name: "catDynamics",

  components: { CatCard },
  data: () => ({
    serviceName: "Qrland",
    componentName: "catDynamics",
    helpData: [],

    categories: [
      {
        name: "کارت ویزیت الکترونیکی",
        value: "",
        route: "qr.cardVisit",
        colors: ["#FF8008", "#FFC837", "#FF8008"],
        icon: "mdi-card-account-details-outline",
      },
      {
        name: "گالری تصاویر",
        value: "",
        route: "qr.photo",
        colors: ["#0093E9", "#80D0C7", "#0093E9"],
        icon: "mdi-image-area",
        isTest: false,
      },
      {
        name: "گالری ویدئو",
        value: "",
        route: "qr.video",
        colors: ["#EE91E9", "#8ED2C7", "#EE98E9"],
        icon: "mdi-image-area",
        isTest: false,
      },
      {
        name: "شبکه های اجتماعی",
        value: "",
        route: "qr.socialMedia",
        colors: ["#93291E", "#ED213A", "#93291E"],
        icon: "mdi-instagram",
        isTest: false,
      },
      {
        name: "کاتالوگ/بروشور دیجیتالی",
        value: "",
        route: "qr.notebook",
        colors: ["#93291E", "#ED213A", "#93291E"],
        icon: "mdi-notebook",
        comingSoon: true,
      },
      {
        name: "سوالات متداول",
        value: "",
        route: "qr.link",
        colors: ["#2c3e50", "#2980b9", "#2c3e50"],
        icon: "mdi-help",
        comingSoon: true,
      },
      {
        name: "کد تخفیف",
        value: "",
        route: "qr.link",
        colors: ["#6a3093", "#a044ff", "#6a3093"],
        icon: "mdi-sale",
        comingSoon: true,
      },
      {
        name: "معرفی محصول",
        value: "",
        route: "qr.link",
        colors: ["#e43a15", "#e65245", "#e43a15"],
        icon: "mdi-archive-check",
        comingSoon: true,
      },
      {
        name: "ثبت بازخورد و نظرسنجی",
        value: "",
        route: "qr.link",
        colors: ["#FF8008", "#FFC837", "#FF8008"],
        icon: "mdi-reply-circle",
        comingSoon: true,
      },
      {
        name: "ثبت درخواست مشاوره",
        value: "",
        route: "qr.link",
        colors: ["#0093E9", "#80D0C7", "#0093E9"],
        icon: "mdi-handshake",
        comingSoon: true,
      },
      {
        name: "ارائه اپلیکیشن",
        value: "",
        route: "qr.link",
        colors: ["#93291E", "#ED213A", "#93291E"],
        icon: "mdi-application-braces-outline",
        comingSoon: true,
      },
      {
        name: "کتاب/مجله/ماهنامه",
        value: "",
        route: "qr.link",
        colors: ["#2c3e50", "#2980b9", "#2c3e50"],
        icon: "mdi-book-open-blank-variant",
        comingSoon: true,
      },
      {
        name: "جدول برنامه ریزی",
        value: "",
        route: "qr.link",
        colors: ["#6a3093", "#a044ff", "#6a3093"],
        icon: "mdi-table-large-plus",
        comingSoon: true,
      },
      {
        name: "کارت دعوت",
        value: "",
        route: "qr.link",
        colors: ["#e43a15", "#e65245", "#e43a15"],
        icon: "mdi-email-open-heart-outline",
        comingSoon: true,
      },
      {
        name: "فیدبک",
        value: "",
        route: "qr.link",
        colors: ["#FF8008", "#FFC837", "#FF8008"],
        icon: "mdi-comment-quote",
        comingSoon: true,
      },
      {
        name: "باشگاه مشتریان",
        value: "",
        route: "qr.link",
        colors: ["#0093E9", "#80D0C7", "#0093E9"],
        icon: "mdi-face-agent",
        comingSoon: true,
      },
      {
        name: "مسیریابی",
        value: "",
        route: "qr.link",
        colors: ["#2c3e50", "#2980b9", "#2c3e50"],
        icon: "mdi-map-marker-path",
        comingSoon: true,
      },
      {
        name: "شمارنده معکوس",
        value: "",
        route: "qr.link",
        colors: ["#6a3093", "#a044ff", "#6a3093"],
        icon: "mdi-timer-check-outline",
        comingSoon: true,
      },
      {
        name: "سنگ قبر",
        value: "",
        route: "qr.link",
        colors: ["#e43a15", "#e65245", "#e43a15"],
        icon: "mdi-cross",
        comingSoon: true,
      },
    ],
  }),
};
</script>

<style scoped></style>
